import {
  Component,
  HostBinding,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UmssButtonComponent } from '../button/button.component';

@Component({
  selector: 'umss-dialog-footer',
  standalone: true,
  imports: [CommonModule, UmssButtonComponent],
  templateUrl: './dialog-footer.component.html',
  styleUrls: ['./dialog-footer.component.scss']
})
export class UmssDialogFooterComponent {
  @HostBinding('style.display') display = 'contents';

  constructor() {}

  /** Button props */
  @Input() primaryButtonLabel?: string | null = 'Confirm';
  @Input() secondaryButtonLabel?: string | null = 'Cancel';
  @Input() primaryButtonVariant:
    | 'Primary'
    | 'Secondary'
    | 'Destructive'
    | 'Ghost'
    | 'Outline' = 'Primary';
  @Input() secondaryButtonVariant:
    | 'Primary'
    | 'Secondary'
    | 'Destructive'
    | 'Ghost'
    | 'Outline' = 'Outline';
  @Input() buttonSize: 'Mini' | 'Small' | 'Regular' | 'Large' = 'Regular';
  @Input() primaryButtonDisabled: boolean = false;
  @Input() secondaryButtonDisabled: boolean = false;
  @Input() primaryButtonLeftIconName?: string;
  @Input() primaryButtonRightIconName?: string;
  @Input() secondaryButtonLeftIconName?: string;
  @Input() secondaryButtonRightIconName?: string;
  /** Tertiary button props (optional third button) */
  @Input() tertiaryButtonLabel?: string | null;
  @Input() tertiaryButtonVariant:
    | 'Primary'
    | 'Secondary'
    | 'Destructive'
    | 'Ghost'
    | 'Outline' = 'Secondary';
  @Input() tertiaryButtonDisabled: boolean = false;
  @Input() tertiaryButtonLeftIconName?: string;
  @Input() tertiaryButtonRightIconName?: string;
  /** Variant props */
  @Input() type = '2 Buttons Right';
  /** Style props */
  @Input() dialogFooterAlignSelf: string | number = '';
  @Input() dialogFooterWidth: string | number = '';

  /** Global busy flag: disables every button while true */
  @Input() loading: boolean = false;
  /** Per-button spinner overrides; defaults keep existing behavior when unset */
  @Input() primaryButtonLoading?: boolean;
  @Input() secondaryButtonLoading?: boolean;
  @Input() tertiaryButtonLoading?: boolean;

  /** Events */
  @Output() onPrimaryClick = new EventEmitter<void>();
  @Output() onSecondaryClick = new EventEmitter<void>();
  @Output() onTertiaryClick = new EventEmitter<void>();

  get dialogFooterStyle() {
    return {
      'align-self': this.dialogFooterAlignSelf,
      width: this.dialogFooterWidth
    };
  }

  handlePrimaryClick() {
    this.onPrimaryClick.emit();
  }

  handleSecondaryClick() {
    this.onSecondaryClick.emit();
  }

  handleTertiaryClick() {
    this.onTertiaryClick.emit();
  }
}
